import * as geolib from 'geolib';
import React from 'react';
import PropTypes from 'prop-types';
import { Box, List, ListItem } from '@mui/material';
import { Place as PlaceIcon } from '@mui/icons-material';
import EmptyStatesForTab from './EmptyStatesForTab';
import { RECORDS_STATUS } from '../../../Constants';
import { loginPageStyles } from '../../../styles';
import erroralert from '../../../assets/Images/erroralert.svg';
import { useSelector } from 'react-redux';
import { Loader } from '../../../Components';
const RoutePracticesTab = ({
  practices,
  route_name,
  tabIndex,
  searchValue,
  locationCoordinates,
}) => {
  const classes = loginPageStyles();
  const loading = useSelector((state) => state.practicesReducer.loading);
  // We will show spinner if route practices are loading
  if (loading) {
    return <Loader loading={loading} />;
  }
  return (
    <Box sx={{ height: '100%' }}>
      {practices.length === 0 && searchValue !== '' ? (
        <EmptyStatesForTab title={RECORDS_STATUS[5]?.title} />
      ) : practices.length === 0 ? (
        <EmptyStatesForTab
          title={RECORDS_STATUS[tabIndex]?.title}
          description={RECORDS_STATUS[tabIndex]?.description}
        />
      ) : (
        <>
          <Box
            sx={{
              bgcolor: '#054E8B',
              display: 'flex',
              padding: '4px 20px',
              color: '#FAFAFA',
              justifyContent: 'space-between',
              lineHeight: '20px',
              fontSize: '15px',
            }}
          >
            <Box
              className={classes.heading10}
              sx={{
                fontWeight: '700',
                textAlign: 'end',
                pt: '16px',
              }}
            >
              Route - {route_name}
            </Box>
          </Box>
          <List
            sx={{
              height: 'auto',
              overflow: 'auto',
              p: 0,
            }}
          >
            {practices.map((element, index) => {
              return (
                <ListItem
                  key={index}
                  sx={{
                    borderBottom: '1px solid #DAE0EB',
                    padding: '8px 12px',
                    gap: '4px',
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: 'background.paper',
                      width: 1,
                      display: 'flex',
                      direction: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        width: '100%',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            width: '100%',
                            lineHeight: '22px',
                            alignItems: 'center',
                          }}
                        >
                          <Box
                            className={classes.heading10}
                            sx={{
                              color: '#000000',
                              fontWeight: '700',
                              fontSize: '17px',
                              width: '100%',
                            }}
                          >
                            {element.name}
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: '11px',
                              alignItems: 'center',
                            }}
                          >
                            <img
                              src={erroralert}
                              alt=""
                              style={{ width: '18px', height: '18px' }}
                            />

                            <Box
                              className={classes.heading}
                              sx={{
                                color: '#8493AE',
                                fontWeight: '400',
                                fontSize: '13px',
                                lineHeight: '16px',
                              }}
                            >
                              {element.latitude &&
                              element.longitude &&
                              locationCoordinates
                                ? Number(
                                    geolib.convertDistance(
                                      geolib.getPreciseDistance(
                                        {
                                          latitude: parseFloat(
                                            element.latitude
                                          ),
                                          longitude: parseFloat(
                                            element.longitude
                                          ),
                                        },
                                        {
                                          latitude:
                                            locationCoordinates?.latitude,
                                          longitude:
                                            locationCoordinates?.longitude,
                                        }
                                      ),
                                      'km'
                                    )
                                  ).toFixed(2)
                                : 'N/A'}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                          <PlaceIcon
                            sx={{
                              fontSize: 18,
                              marginRight: '7px',
                              color: '#8493AE',
                            }}
                          />
                          <Box
                            className={classes.heading}
                            sx={{
                              fontSize: '12px',
                              fontFamily: 'Mulish',
                              fontWeight: '400',
                              lineHeight: '16px',
                              color: '#455066',
                            }}
                          >
                            {element.address}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </ListItem>
              );
            })}
          </List>
        </>
      )}
    </Box>
  );
};
RoutePracticesTab.propTypes = {
  practices: PropTypes.array,
  route_name: PropTypes.string,
  tabIndex: PropTypes.number,
  locationCoordinates: PropTypes.object,
  searchValue: PropTypes.string,
};
export default RoutePracticesTab;
